import { type GAEvent, gaPush as sharedGaPush } from '@servicecare/frontend-starter';

// Skip pushing GA4 events in dev builds (matches the behavior previously
// implemented inside the local googleAnalytics.ts, now that
// @servicecare/frontend-starter requires the caller to compute and pass this
// flag explicitly).
const gaPushOptions = { isDev: import.meta.env.DEV };

// TODO To be removed/updated when a new project is created.
type AnalyticsEvent = 'stencil_test_event';

// Wraps the shared gaPush with this vertical's event union and isDev option,
// so call sites below read exactly like they did against the old local
// googleAnalytics.ts, and the wrapper is named the same way across verticals.
const gaPush = (gaEvent: GAEvent<AnalyticsEvent>) => sharedGaPush<AnalyticsEvent>(gaEvent, gaPushOptions);

const AnalyticsEvents = {
    clickCloseButton: () => {
        gaPush({
            event: 'stencil_test_event',
            parameters: {
                element_name: 'ExampleComponent',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'example_page',
                element_state: `date:${Date.now()}`,
            },
            userProps: {},
        });
    },
};

export default AnalyticsEvents;
